export default {
    default: (toAnimate= ['all'], duration = '.25s') => toAnimate.map(item => `${item} ${duration} cubic-bezier(0.25, 0.46, 0.45, 0.94)`).join(',')
}